import React from 'react';
import classnames from 'classnames';
import useIntlExtend from '@intelligence/hooks/useIntlExtend';

interface IFilterStickyHeaderIndicatorProps extends IBaseProps {
  text: string;
  icon?: React.ReactNode;
}

const FilterStickyHeaderIndicator: React.FC<IFilterStickyHeaderIndicatorProps> = (props) => {
  const { style, className, text, icon } = props;

  const { formatMessage } = useIntlExtend();

  return (
    <div style={style} className={classnames('dbi-filter-sticky-header__saved-filter', className)}>
      {React.isValidElement(icon) && icon}
      <span className="dbi-filter-sticky-header__saved-filter-text">{formatMessage({ id: text })}</span>
    </div>
  );
};

export default FilterStickyHeaderIndicator;
